import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Gauge, LineChart, Trophy } from 'lucide-react';

const ReportsHome: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
          <p className="mt-2 text-sm text-gray-700">
            Choose a report to view detailed insights and export data for your teams.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <Link
          to="/dashboard/reports/batch-efficiency"
          className="group bg-white shadow rounded-lg border border-gray-100 p-6 hover:border-primary-200 hover:shadow-md transition"
        >
          <div className="flex items-start gap-4">
            <div className="rounded-full bg-emerald-50 p-3 text-emerald-600">
              <Gauge className="h-6 w-6" />
            </div>
            <div className="space-y-2">
              <h2 className="text-lg font-semibold text-gray-900 group-hover:text-primary-700">
                Batch Efficiency Report
              </h2>
              <p className="text-sm text-gray-600">
                Track launchpad, assessment, certification, and placement efficiency for each batch.
              </p>
              <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:underline">
                View report
              </span>
            </div>
          </div>
        </Link>

        <Link
          to="/dashboard/reports/planned-vs-actual"
          className="group bg-white shadow rounded-lg border border-gray-100 p-6 hover:border-primary-200 hover:shadow-md transition"
        >
          <div className="flex items-start gap-4">
            <div className="rounded-full bg-primary-50 p-3 text-primary-600">
              <LineChart className="h-6 w-6" />
            </div>
            <div className="space-y-2">
              <h2 className="text-lg font-semibold text-gray-900 group-hover:text-primary-700">
                Planned vs Actual Report
              </h2>
              <p className="text-sm text-gray-600">
                Compare planned timelines with actual execution across batches to spot delays early.
              </p>
              <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:underline">
                View report
              </span>
            </div>
          </div>
        </Link>

        <Link
          to="/dashboard/reports/partner-performance"
          className="group bg-white shadow rounded-lg border border-gray-100 p-6 hover:border-primary-200 hover:shadow-md transition"
        >
          <div className="flex items-start gap-4">
            <div className="rounded-full bg-amber-50 p-3 text-amber-600">
              <Trophy className="h-6 w-6" />
            </div>
            <div className="space-y-2">
              <h2 className="text-lg font-semibold text-gray-900 group-hover:text-primary-700">
                Partner Performance Report
              </h2>
              <p className="text-sm text-gray-600">
                Compare batch allocation vs completion to rank partners and identify underperformers quickly.
              </p>
              <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:underline">
                View report
              </span>
            </div>
          </div>
        </Link>

        <Link
          to="/dashboard/reports/exceptions"
          className="group bg-white shadow rounded-lg border border-gray-100 p-6 hover:border-primary-200 hover:shadow-md transition"
        >
          <div className="flex items-start gap-4">
            <div className="rounded-full bg-rose-50 p-3 text-rose-600">
              <AlertTriangle className="h-6 w-6" />
            </div>
            <div className="space-y-2">
              <h2 className="text-lg font-semibold text-gray-900 group-hover:text-primary-700">
                Exceptions Report
              </h2>
              <p className="text-sm text-gray-600">
                Daily red flags across modules, including attendance breaches and unresolved inquiries.
              </p>
              <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:underline">
                View report
              </span>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ReportsHome;
